import apiHandler from '../core/apiHandler';

const restaurantTableApi = apiHandler('restaurant/tables');

export default restaurantTableApi;
